import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { cn } from "@/modules/lib/utils"
import { PromoCodeStatus } from "@/modules/promoCode/gateway/promoCodeDto"
import { PercentageIcon } from "@images/svgIcons/percentageIcon"
import { BoxPromoCodeEntity } from "@modules/promoCode/entities/boxPromoCodeEntity"
import { PromoCodeEntity } from "@modules/promoCode/entities/promoCodeEntity"
import { shortenText } from "@modules/utils/stringUtils"
import styled from "styled-components"

type PromoCodeListItemProps = {
  promoCode: PromoCodeEntity | BoxPromoCodeEntity
} & React.ComponentProps<"div">

export function PromoCodeListItem({ promoCode, className, ...props }: PromoCodeListItemProps) {
  const isScheduled = promoCode.archivedStatus === PromoCodeStatus.SCHEDULED
  const isPast =
    !!promoCode.archivedStatus &&
    [PromoCodeStatus.EXPIRED, PromoCodeStatus.MAX_ATTENDEES, PromoCodeStatus.DELETED].includes(promoCode.archivedStatus)

  const status = promoCode.archivedStatus
    ? {
        [PromoCodeStatus.EXPIRED]: word("promoCode.view.expired"),
        [PromoCodeStatus.SCHEDULED]: word("promoCode.view.scheduled"),
        [PromoCodeStatus.MAX_ATTENDEES]: word("promoCode.view.maxAttendeesReached"),
        [PromoCodeStatus.DELETED]: word("promoCode.view.deleted"),
      }[promoCode.archivedStatus]
    : word("promoCode.view.ongoing")

  return (
    <div className={cn("flex flex-row items-center gap-2", className)} {...props}>
      <div className="flex flex-row items-center gap-5">
        <PercentageIconContainer $isPast={isPast} $isScheduled={isScheduled}>
          <PercentageIcon color={isPast ? "var(--neutral-500)" : "var(--secondary-300)"} />
        </PercentageIconContainer>
        <div className="flex flex-col">
          <Text fontStyle="LL" className={cn("font-bold", isPast && "text-textOnSurface-muted")}>
            {shortenText(promoCode.title, 18)}
          </Text>
          <Text fontStyle="BS" className={"text-textOnSurface-muted"}>
            {status}
          </Text>
        </div>
      </div>
    </div>
  )
}

const PercentageIconContainer = styled.div<{ $isPast: boolean; $isScheduled: boolean }>`
  min-width: 46px;
  min-height: 46px;
  background-color: ${({ $isPast }) => ($isPast ? "var(--neutral-200)" : "var(--primary-500)")};
  border-radius: 14px;
  opacity: ${({ $isScheduled }) => ($isScheduled ? 0.5 : 1)};
  display: flex;
  justify-content: center;
  align-items: center;
`
